import { BREAKPOINT_MED } from '../variables';

export default function languagePickerFunctionality() {
  setCorrectLangOnLangPicker();
  addListenerToLangPicker();
  moveLangPickerToHeader();
}

function setCorrectLangOnLangPicker() {
  if ($('html').attr('lang') != 'sv-SE') {
    $('#language-picker').val('English');
  }
}

function addListenerToLangPicker() {
  $('#language-picker').change(function() {
    if ($(this).val() == 'English') {
      if (window.location.search.indexOf('lang=en') < 0) {
        window.location.href = window.location.href + '?lang=en';
      }
    } else {
      if (window.location.search.indexOf('lang=en') > -1) {
        window.location.href = window.location.href.replace('?lang=en', '');
      }
    }
  });
}

function moveLangPickerToHeader() {
  // Flytta in språkväljaren från WPML I utlagd div
  if ($('.langage-select-menu').length > 0) {
    $('.langage-select-menu').appendTo('.header-language-picker').show();

    if ($(document).width() >= BREAKPOINT_MED) {
      $('.header-language-picker').show();
    }
  }

  $('.langage-select-menu').click(function() {
    $('.language-options').toggleClass('open');
  });
}
